import type { TFunction } from 'i18next';
import type { AiModelOption } from '@/services/aiAssistantSettingsService';

/** A catalog model as the settings page lists it: its name, its list price when known, and whether it is down. */
export function aiModelLabel(t: TFunction, option: AiModelOption): string {
  const price = option.currency && option.inputPricePerMillionTokens != null && option.outputPricePerMillionTokens != null
    ? ` — ${t('aiSettings.price', { currency: option.currency, input: option.inputPricePerMillionTokens, output: option.outputPricePerMillionTokens })}`
    : '';
  const down = option.available ? '' : ` ${t('aiSettings.modelDown')}`;
  return `${option.name}${price}${down}`;
}
